<template>
  <div>
    <h1 class="sm:mb-8 text-center text-2xl lg:text-3xl font-semibold">
      Add supplier info
    </h1>
    <section class="flex flex-wrap justify-center">
      <div class="min-w-full sm:min-w-30 max-w-2xl flex-1 m-2">
        <div class="bg-white rounded-lg shadow-card p-8 self-start sm:p-12">
          <div class="sm:flex sm:mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="firstName">First name<small>*</small></label>
              <input type="text" class="input mt-2" id="firstName" v-model="firstName" />
            </fieldset>
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="lastName">Last name<small>*</small></label>
              <input type="text" class="input mt-2" id="lastName" v-model="lastName " />
            </fieldset>
          </div>
          <div class="sm:flex mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="email">Email<small>*</small></label>
              <input type="email" class="input mt-2" id="email" v-model="email" />
            </fieldset>
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="phone">Phone<small>*</small></label>
              <input type="text" class="input mt-2" id="phone" v-mask="'############'" v-model="phone" />
            </fieldset>
          </div>
          <fieldset class="col-start-1 col-end-3">
            <label for="companyName">Company Name</label>
            <input type="text" class="input mt-2" id="companyName" v-model="companyName">
          </fieldset>
          <div class="flex justify-center flex-col-reverse sm:flex-row mt-10">
            <button
              class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-auto sm:flex-none"
              @click="$emit('next')"
            >
              Skip
            </button>
            <button
              class="btn btn-primary font-semibold rounded px-10 w-full sm:w-48 sm:flex-none"
              :disabled="!canSubmit"
              @click="submitSupplier"
            >
              Add Supplier
            </button>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg shadow-card p-8 self-start max-w-sm sm:p-12 m-2">
        <h1 class="mb-3 font-semibold text-lg">
          Helper Info Box
        </h1>
        <p>
          Enter the Name and Email for the Supplier that you will use to build your box and / or supply material items.
          They will be invited as a collaborator on your project and have view access to the box orders as they are
          gathered for procurement.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  import {email, minLength, required} from "vuelidate/lib/validators"
  import { USER_ROLES } from "@/utils/user-roles"

  const TEXT_FIELD_MIN_LENGTH = 2;

  export default {
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        companyName: ''
      }
    },
    validations: {
      firstName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH),
      },
      lastName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
      },
      companyName: {
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      }
    },
    computed: {
      canSubmit() {
        const {firstName, lastName, email, phone, companyName} = this.$v
        return !firstName.$invalid
          && !lastName.$invalid
          && !email.$invalid
          && !phone.$invalid
          && !companyName.$invalid
      }
    },
    methods: {
      async submitSupplier() {
        this.loading = true

        await this.$store.commit('SET_ORDER_COLLABORATOR_INVITATION', {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          company: this.companyName,
          role: USER_ROLES.ROLE_EVENT_PLANNER
        });

        this.loading = false;
        this.$emit('next')
        
      }
    }
  }
</script>